import React from 'react';
import { User, Phone, Mail, Calendar, MapPin, FileText } from 'lucide-react';
import FormInput from '../../FormInput';

const CandidatForm = ({
  formData,
  formErrors,
  sessions,
  onInputChange,
  onSubmit,
  submitting,
  selectedCandidat,
  onCancel
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormInput
          label="Nom"
          type="text"
          name="nom"
          value={formData.nom}
          onChange={onInputChange}
          placeholder="Nom du candidat"
          required
          error={formErrors.nom}
          icon={User}
        />
        
        <FormInput
          label="Prénom"
          type="text"
          name="prenom"
          value={formData.prenom}
          onChange={onInputChange}
          placeholder="Prénom du candidat"
          required
          error={formErrors.prenom}
          icon={User}
        />

        <FormInput
          label="Sexe"
          type="select"
          name="sexe"
          value={formData.sexe}
          onChange={onInputChange}
          options={[
            { value: 'M', label: 'Masculin' },
            { value: 'F', label: 'Féminin' }
          ]}
          required
          error={formErrors.sexe}
          icon={User}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormInput
          label="Date de naissance"
          type="date"
          name="date_naissance"
          value={formData.date_naissance}
          onChange={onInputChange}
          required
          error={formErrors.date_naissance}
          icon={Calendar}
        />
        
        <FormInput
          label="Lieu de naissance"
          type="text"
          name="lieu_naissance"
          value={formData.lieu_naissance}
          onChange={onInputChange}
          placeholder="Lieu de naissance"
          required
          error={formErrors.lieu_naissance}
          icon={MapPin}
        />
        
        <FormInput
          label="Nationalité"
          type="text"
          name="nationalite"
          value={formData.nationalite}
          onChange={onInputChange}
          placeholder="Nationalité"
          required
          error={formErrors.nationalite}
          icon={User}
        />
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormInput
          label="Téléphone"
          type="tel"
          name="telephone"
          value={formData.telephone}
          onChange={onInputChange}
          placeholder="Numéro de téléphone"
          required
          error={formErrors.telephone}
          icon={Phone}
        />
        
        <FormInput
          label="Email"
          type="email"
          name="email"
          value={formData.email}
          onChange={onInputChange}
          placeholder="Adresse email"
          required
          error={formErrors.email}
          icon={Mail}
        />
        
        <FormInput
          label="Session de concours"
          type="select"
          name="session_concours"
          value={formData.session_concours}
          onChange={onInputChange}
          options={[
            { value: '', label: 'Sélectionner une session' },
            ...sessions.map(session => ({ 
              value: session.id, 
              label: `${session.nom} - ${session.type_concours?.nom}` 
            }))
          ]}
          required
          error={formErrors.session_concours}
          icon={FileText}
        />
      </div>
      
      <div className="grid grid-cols-1 gap-4">
        <FormInput
          label="Adresse"
          type="textarea"
          name="adresse"
          value={formData.adresse}
          onChange={onInputChange}
          placeholder="Adresse de résidence"
          required
          error={formErrors.adresse}
          icon={MapPin}
          rows={3}
        />
      </div>

      <div className="text-sm text-gray-500 mt-4">
        <span className="text-red-500">*</span> Champs obligatoires
      </div>

      {/* Footer avec boutons */}
      <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
        <button
          type="button"
          className="inline-flex justify-center px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          onClick={onCancel}
        >
          Annuler
        </button>
        <button
          type="submit"
          className={`inline-flex justify-center px-6 py-2.5 text-sm font-medium text-white bg-[#202654] border border-transparent rounded-md shadow-sm hover:bg-[#161c3f] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654] ${submitting ? 'opacity-75 cursor-not-allowed' : ''}`}
          disabled={submitting}
        >
          {submitting ? (
            <>
              <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Traitement...
            </>
          ) : (
            selectedCandidat ? 'Mettre à jour' : 'Créer'
          )}
        </button>
      </div>
    </form>
  );
};

export default CandidatForm; 